"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * オブジェクト操作ユーティリティ
 */

/**
 * keysに一致する値をobjから取り出して、新しいオブジェクトを返却する
 *
 * @param {object} obj
 * @param {Array} keys
 */
const cloneMatchedKey = (obj, keys) => {
  const result = {};
  for (let key of keys) {
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};
var _default = exports.default = Object.freeze({
  cloneMatchedKey
});